export class DisplayNews{
	init(){
		let newsImage 	= $('.news--image'),
				newsBoxes 	= $('.news--boxes'),
				windowWidth = $(window).width();

		var newsImageLength = newsImage.length;
		if( newsImageLength ){
			for(var i = newsImageLength; i--;){
				let thisNews 							= newsImage[i],
						thisNewsWidth 				= $(thisNews).width(),
						newsImageItems 				= $(thisNews).find('.news__item'),
						newsImageItemsLength 	= newsImageItems.length;

				let largeWidth 	= (1180 / 12) * 8 + 40,
						middleWidth = (1180 / 12) * 6 + 40,
						smallWidth 	= (1180 / 12) * 4 + 40;

				
				if($(thisNews).hasClass('news--image-side')){
					if( thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth || thisNewsWidth < smallWidth ){
						$(thisNews).find('.news__item').addClass('display-column');
					}else{
						$(thisNews).find('.news__item').removeClass('display-column');
					}
				}
				if( thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth ){
					newsImageItems.removeClass('same-width-1 same-width-2').addClass('same-width-3');
				}else if( thisNewsWidth < middleWidth && thisNewsWidth > smallWidth ){
					newsImageItems.removeClass('same-width-1 same-width-3').addClass('same-width-2');
				}else if( thisNewsWidth < smallWidth ){
					newsImageItems.removeClass('same-width-2 same-width-3').addClass('same-width-1');
				}else{
					newsImageItems.removeClass('same-width-1 same-width-2 same-width-3');
				}
			}
		}


		var newsBoxesLength = newsBoxes.length;
		if( newsBoxesLength ){
			for(var i = newsBoxesLength; i--;){
				let thisNews 		= newsBoxes[i],
						newsHeight 	= 0,
						newsItems 	= $(thisNews).find('.news__item');

				newsItems.each(function(id, item){
					var itemHeight = $(item).height();
					if( itemHeight > newsHeight ){
						newsHeight = itemHeight;
					}
				});

				newsItems.find('.ni__content').innerHeight(newsHeight);
			}
		}
	}
}